/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Local_Output_Folder_LabelInputs */



/**
* | output |
* | --- |
* | "Output folder" |
*
* @param {Embed_Captions_Local_Output_Folder_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_local_output_folder_label = /** @type {((inputs?: Embed_Captions_Local_Output_Folder_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Local_Output_Folder_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dossier de sortie")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgabeverzeichnis")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cartella di output")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выходная папка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Carpeta de salida")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("输出文件夹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("出力フォルダ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("भेजी गयी चीजों का फोल्डर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pasta de saída")
	return /** @type {LocalizedString} */ ("Output folder")
});